import { Product } from "@omni/types/api/product/bff/product.model";
import { ProductFieldSet } from "@omni/types/api/product/bff/shared/enums/productFieldSet.enum";
import queryString from "query-string";
import { useEffect } from "react";

import { useCustomerServiceApi } from "@/api/hooks/customerService.hook";
import { useBFFProductServiceApi } from "@/api/hooks/productService.hook";
import { DefaultFor } from "@/api/mappers/default.mapper";
import { MessageComponent } from "@/components/General/Messages/messages.component";
import { Spinner } from "@/components/General/Spinner/spinner.component";
import { WishlistModel } from "@/redux/modules/api/data/wishlist/@types/wishlist.model";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

import { WishlistDetailComponent } from "./WishlistDetail.component";

const WishlistShareableDetailContainer = () => {
    const { id: listId } = queryString.parse(location.search);
    const { t } = useGranite();

    const [{ data: sharedWishlist, loading: isLoadingSharedList }] =
        useCustomerServiceApi(
            {
                url: `/shared-wishlists/:listId`,
                method: "GET",
                urlParams: {
                    listId: listId ? (listId as string) : ""
                },
                mapper: DefaultFor<WishlistModel>()
            },
            { autoCancel: false, manual: !listId }
        );

    const [{ data, loading }, getProducts] = useBFFProductServiceApi<
        any,
        any,
        Array<Product<ProductFieldSet.ProductTile>>
    >(
        {
            url: `/products`,
            method: "GET"
        },
        { autoCancel: false, manual: true }
    );

    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    useEffect(() => {
        if (!(sharedWishlist?.products || []).length) {
            return;
        }

        getProducts({
            params: {
                sku: sharedWishlist?.products.map((p) => p.sku).join(","),
                fields: ProductFieldSet.ProductTile
            }
        });
    }, [sharedWishlist]);

    if (isLoadingSharedList || loading) {
        return <Spinner />;
    }

    return (
        <>
            {!listId && (
                <MessageComponent
                    message={{
                        id: "empty-wishlist",
                        status: "info",
                        text: t("wishlist.detail.empty.list"),
                        dismissible: false
                    }}
                />
            )}
            {sharedWishlist && (
                <WishlistDetailComponent
                    columnSettings={{
                        default: 12,
                        sm: 6,
                        md: 4,
                        lg: 4,
                        xl: 3
                    }}
                    list={sharedWishlist}
                    products={data || []}
                    isLoggedIn={false}
                    canMove={false}
                />
            )}
        </>
    );
};

export { WishlistShareableDetailContainer };
